import React from 'react';

type TabNavigationSkeletonProps = {
  title?: string;
};

const TabNavigationSkeleton: React.FC<TabNavigationSkeletonProps> = ({
  title,
}) => {
  return (
    <div
      className="w-full flex flex-col justify-center items-center px-6 lg:px-14"
      data-testid="tab-navigation-skeleton"
      id="tab-navigation-skeleton"
    >
      {title && (
        <div
          data-testid="title-skeleton"
          className="max-w-full w-[650px] h-8 lg:h-12 bg-slate-300 rounded mt-8 lg:mt-20 mb-2 lg:mb-10"
        />
      )}

      <div
        data-testid="tabs-skeleton"
        className="max-w-full w-[450px] h-[98px] bg-slate-300 rounded"
      />

      <div
        data-testid="tab-content-skeleton"
        className="my-8 lg:my-16 max-w-full w-[1480px] h-[500px] bg-slate-300 rounded"
      />
    </div>
  );
};

export default React.memo(TabNavigationSkeleton);
